const API_HOST = () => {
  const { host } = window.location
  if (host.includes('localhost') || host.includes('hlg')) {
    return 'https://hlg.api.support-query.grupoa.education'
  }
  return 'https://api.support-query.grupoa.education'
}

const API_AUTH_HOST = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('hlg')) {
    return 'https://hlg-api-client.safea.grupoa.education/v1'
  }
  return 'https://api-client.safea.grupoa.education/v1'
}

const SAFE_A_KEY = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('hlg')) {
    return 'RBETS8UHfq3Sw8sB4HZtA9WSV3t639lIaVuuQ8vP'
  }
  return 'XTvekAiSRv3uhE0yVEpTx2ilVzWWkHqxaeNPcMen'
}

const API_URL = `${API_HOST()}/api/v1`
const API_URL_AUTH = API_AUTH_HOST()
const API_USER = `${API_URL_AUTH}/user`
const API_QUERIES = `${API_URL}/query`
const API_DATABASES = `${API_URL}/database`
const API_EXECUTE_QUERY = `${API_URL}/execute`

export default {
  API_HOST,
  API_URL,
  API_URL_AUTH,
  API_USER,
  API_QUERIES,
  API_DATABASES,
  API_EXECUTE_QUERY,
  SAFE_A_KEY
}
